import React from "react";

import { Col, Icon, Link, Row } from "components";

export const PaymentInfo = ({ farm, t }) =>
  farm.bankingDetails && (
    <section className="padded-small payment-info">
      <section className="container tiny">
        <Row>
          <Col>
            <h2>
              <span>{t("paymentInformation.title")}</span>
              <Link to="/banking-details" mixpanelText="edit-banking-details" className="right">
                <Icon iconName="klim/edit-element" className="icon inline" />
              </Link>
            </h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <p>{farm.bankingDetails.accountHolder}</p>
            <p>
              {t("iban")}: {farm.bankingDetails.iban ? farm.bankingDetails.iban.slice(0, farm.bankingDetails.iban.length - 5).replace(/[^\s]/g, "-") : ""}
              {farm.bankingDetails.iban ? farm.bankingDetails.iban.slice(-5) : ""}
            </p>
          </Col>
        </Row>
      </section>
    </section>
  );
